import styled from 'styled-components'

export const Button = styled.button`
  color: var(--primaryColor);
  padding: 10px 24px;
  border: none;
  background-color: #4caf50;
  cursor: pointer;
  transition-duration: 0.4s;
  text-align: center;
  text-decoration: none;

  &:hover {
    background-color: #317133;
  }
`
